import { useNavigate, useParams } from "react-router-dom";
import { PODCAST_LIST_ROUTE, PODCAST_UPDATE_ROUTE } from "constants/routeEnum";
import callApi from "Common/utils/apiCaller";
import * as Yup from "yup";
import { useFormik } from "formik";
import { X } from "lucide-react";
import { showNotification } from "Common/utils/Notification";
import { useEffect, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { imageUploader } from "Common/utils/imageUploader";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "Common/utils/ImageDomain";
import PermissionSwitch from "../../Common/Components/PermissionLocks/PermissionSwitch";
import { ToastContainer } from "react-toastify";
import BreadCrumb from "Common/BreadCrumb";
import Drawer from "Common/Components/Drawer";
import ImageView from "Common/Components/ImageView/ImageView";
import video from "../../images/video.svg";
import audio from "../../images/Speaker_Icon.svg";
import LoaderComponent from "Common/Components/Loader/Loader";
import ToggleSwitch from "Common/Components/ToggleSwitch/ToggleSwitch";
import CustomInput from "Common/Components/InputFields/CustomInput";
import MetaData from "Common/MetaData";
import ReactSelect from "Common/Components/ReactSelect/ReactSelect";
import moment from "moment";
import CustomDateInput from "Common/Components/InputFields/CustomDateInput";

const UpdatePodcast = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState<any>({ released_at: "" });
  const { id } = useParams();
  const [version, setVersion] = useState<any>();
  const [thumbnailUrl, setThumbnailUrl] = useState<any>({
    thumbnail_url: "",
    thumbnail_id: "",
  });
  const [addTags, setAddTags] = useState<any>();
  const [mediaType, setMediaType] = useState<any>("");
  const [index, setIndex] = useState<any>(undefined);
  const [showApprove, setShowApprove] = useState(false);
  const [imageLink, setImageLink] = useState<any>();
  const [podcastData, setPodcastData] = useState<any>();
  const [loader, setLoader] = useState<any>(false);
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [showMeta, setShowMeta] = useState<any>(false);
  const toggleMeta = () => setShowMeta(!showMeta);
  const [option, setOption] = useState<any>([]);
  const [isActive, setIsActive] = useState<any>(false);
  const [metaEdit, setMetaEdit] = useState<any>({
    url: "",
    page_title: "",
    meta_description: "",
    meta_keyword: "",
    canonical_url: "",
  });
  const [errors, setErrors] = useState<any>();

  useEffect(() => {
    fetchData("podcast-model-tags");
  }, []);

  const fetchData = async (code) => {
    try {
      const res = await callApi(`v1/content/code/${code}`, "get", {});
      if (res.status === "Success") {
        setOption(res.data.content.params);
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };
  const handleTagChange = (keyName, event: any) => {
    setAddTags(event);
  };
  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (index === undefined) {
        if (
          imageData?.media_type === "audio" ||
          imageData?.media_type === "video"
        ) {
          setImageLink(imageData);
          setMediaType(imageData?.media_type);
        } else {
          showNotification(
            "The media type should be either audio or video.",
            "error"
          );
        }
      } else if (index === "media") {
        if (imageData?.media_type === "image") {
          setThumbnailUrl((prev) => ({
            ...prev,
            ["thumbnail_url"]: imageData?.media_url,
          }));
          setThumbnailUrl((prev) => ({
            ...prev,
            ["thumbnail_id"]: imageData?._id,
          }));
        } else {
          showNotification("The media type should be image", "error");
        }
      }
    }
  }, [imageData, index]);
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      user: profile.user,
    })
  );

  const { permission, user } = useSelector(selectProperties);

  async function fetchPodcast(id: any) {
    try {
      const res = await callApi(`v1/podcast/${id}`, "get", {});
      if (res && res?.status === "Success") {
        setAddTags({
          label: res.data.podcast.tags,
          value: res.data.podcast.tags,
        });
        setFormData({
          released_at: res.data.podcast?.released_at,
        });
        setMetaEdit(res.data.podcast);
        setMediaType(res.data.podcast?.podcast_media_type);
        setImageLink(res.data.podcast);
        setPodcastData(res.data.podcast);
        setIsActive(res.data.podcast.is_active);
        setThumbnailUrl((prev) => ({
          ...prev,
          ["thumbnail_url"]: res.data.podcast.thumbnail_url,
        }));
      }
    } catch (e) {
      showNotification("something went wrong", "error");
    }
  }
  useEffect(() => {
    if (id) {
      fetchPodcast(id);
      fetchVersionList(id);
    }
  }, [id]);

  const showError = (keyName) => {
    return errors && errors[keyName] ? (
      <p className="text-red-500 text-[14px]  pt-2">{errors[keyName]}</p>
    ) : null;
  };

const handleMetaChange = (keyName, keyValue) => {
  setMetaEdit((prev) => ({
    ...prev,
    [`updated_${keyName}`]: keyValue,
    is_meta_edited: true, 
  }));
  setErrors((prev) => ({
    ...prev,
    [`updated_${keyName}`]: "",
  }));
};

  const handleValidate = (data: any) => {
    let isValid = true;
    let error: { [index: string]: any } = {};
    if (!data?.url || data?.url === "") {
      isValid = false;
      error["url"] = "Please enter url";
    }
    // if (!data?.canonical_url || data?.canonical_url === "") {
    //   isValid = false;
    //   error["canonical_url"] = "Please enter canonical url";
    // }
    if (!data?.page_title || data?.page_title === "") {
      isValid = false;
      error["page_title"] = "Please enter page title";
    }
    if (!data?.meta_description || data?.meta_description === "") {
      isValid = false;
      error["meta_description"] = "Please enter meta description";
    }
    // if (!data?.meta_keyword || data?.meta_keyword === "") {
    //   isValid = false;
    //   error["meta_keyword"] = "Please enter meta keyword";
    // }
    return {
      isValid,
      error,
    };
  };
  const handleMetaData = async () => {
    let check = handleValidate(metaEdit);
    if (check.isValid) {
      try {
        const res = await callApi(
          `v1/podcast/${podcastData?.url}/update-podcast`,
          {
            ...metaEdit,
          }
        );
        if (res && res?.status === "Success") {
          showNotification("Updated successfully", "success");
        }
      } catch (e) {
        showNotification(
          e.response.data.data.message || "Error occured",
          "error"
        );
      }
    } else {
      setErrors(check.error);
    }
  };

  const fetchVersionList = async (id) => {
    try {
      const res = await callApi(`v1/podcast/${id}/version-list`, "get", {});
      if (res && res?.status === "Success") {
        setVersion(res.data?.copies);
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };
  const handleApprove = async () => {
    if (!podcastData) {
      showNotification("Page data is missing. Please try again.", "error");
      return;
    }
    try {
      const response = await callApi(
        `v1/podcast/url/${podcastData?.url}/approve`,
        "get",
        {}
      );
      if (response?.status === "Success") {
        setLoader(!loader);
        showNotification("Page approved successfully", "success");
        fetchPodcast(id);
        setShowApprove(true);
      }
    } catch (error) {
      showNotification(
        "An error occurred while publishing the page. Please try again.",
        "error"
      );
    }
  };
  const handlePublish = async (url: any) => {
    try {
      const res = await callApi(`v1/podcast/${url}/publish-podcast`, "get", {});
      if (res && res?.status === "Success") {
        setLoader(!loader);
        showNotification("Published successfully", "success");
        setShowApprove(false);
        fetchPodcast(id);
      }
    } catch (e) {
      showNotification(
        e.response.data.data.message || "Error occured",
        "error"
      );
    }
  };

  const userHasPermissionToApprovePage = () => {
    return permission?.permissions?.includes("podcast:verify");
  };

  const userHasPermissionToPublishPage = () => {
    return permission?.permissions?.includes("podcast:publish");
  };
  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      heading: podcastData?.heading || "",
      // podcast_url: imageLink?.media_url || imageLink?.podcast_url,
    },
    validationSchema: Yup.object({
      heading: Yup.string().required("Please Enter heading"),
      // podcast_url: Yup.string().required("Please Enter podcast url"),
    }),

    onSubmit: async (values) => {
      const updateData = {
        ...values,
      };
      // if (!imageLink?.media_url) {
      //   showNotification("Please add video or audio", "error");
      //   return;
      // }
      if (!!!thumbnailUrl?.thumbnail_url) {
        showNotification("Please add image", "error");
        return;
      }
      try {
        setIsLoading(true);
        const res = await callApi(
          `v1/podcast/${podcastData?.url}/update-podcast`,
          "post",
          {
            podcast_url: imageLink?.media_url || podcastData?.podcast_url,
            content_type: imageLink?.content_type,
            heading: values?.heading,
            is_active: isActive,
            ...thumbnailUrl,
            podcast_media_type: mediaType,
            tags: addTags?.value ? addTags?.value : null,
            url: podcastData?.url,
            ...formData,
          }
        );
        setIsLoading(false);
        if (res && res?.status === "Success") {
          showNotification("Podcast created successfully", "success");
          setImageLink("");
          fetchPodcast(id);
          setIsLoading(true);
          setTimeout(() => {
            navigate(PODCAST_LIST_ROUTE);
            setIsLoading(false);
          }, 800);
        }
      } catch (e) {
        showNotification("something went wrong", "error");
        setIsLoading(false);
      }
    },
  });
  const hasEditMode = () => {
    return podcastData?.is_edit;
  };
  const hasApproved = () => {
    return podcastData?.is_approved;
  };
  const toggleVisiblity = (pageId, isActive) => {
    setIsActive(isActive);
  };

  return (
    <>
      <div className="flex justify-between mt-2">
        <BreadCrumb
          title={PODCAST_UPDATE_ROUTE}
          pageTitle={PODCAST_LIST_ROUTE}
          version="v1"
        />
        <div>
          {userHasPermissionToApprovePage() &&
            hasEditMode() &&
            !showApprove && (
              <div
                className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                onClick={handleApprove}
              >
                Approve
              </div>
            )}
          {userHasPermissionToPublishPage() && showApprove && hasApproved() && (
            <button
              type="button"
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              onClick={() => {
                handlePublish(podcastData?.url);
              }}
            >
              <span className="align-middle">Publish</span>
            </button>
          )}
          <button
            type="button"
            className="ml-2 text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            onClick={() => toggleMeta()}
          >
            <span className="align-middle">Edit Meta</span>
          </button>
        </div>
      </div>
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <ToggleSwitch
                selectValue={isActive}
                versionValue={podcastData?.is_active}
                toggle={() => toggleVisiblity(podcastData?.id, !isActive)}
                label="Is Podcast Active?"
                required={true}
              />
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <CustomInput
                    label="Heading"
                    name="heading"
                    type="text"
                    value={validation.values.heading}
                    placeholder="Enter heading"
                    onChange={validation.handleChange}
                    isVersioned={version?.heading ? true : false}
                    versionedValue={version?.heading}
                  />
                  {validation.touched.heading && validation.errors.heading ? (
                    <p className="text-red-400">{validation.errors.heading}</p>
                  ) : null}
                </div>
              </div>
              <div>
                <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                  <div className="xl:col-span-12"></div>
                  <div className="xl:col-span-12">
                    <label
                      htmlFor="phoneNumberInput"
                      className="inline-block mb-2 text-base font-medium"
                    >
                      Tags
                    </label>
                    <ReactSelect
                      options={option}
                      isSearchable={false}
                      isMulti={false}
                      placeholder={"Please select tags"}
                      contentType={addTags}
                      handleContentChange={handleTagChange}
                      name={"tagss"}
                      id={"tags-types1"}
                      versionData={{
                        label: version?.tags?.[0],
                        value: version?.tags?.[0],
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="m-4 xl:col-span-12">
                {imageLink ? (
                  <div className="flex items-center">
                    <div className="relative w-40 h-40 ">
                      {imageLink?.podcast_media_type === "video" ||
                      imageLink.media_type === "video" ? (
                        <img src={video} alt="img" className="w-40 h-40" />
                      ) : (
                        <img src={audio} alt="img" className="w-40 h-40" />
                      )}
                      <span
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "6px",
                          fontSize: "22px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setImageData(null);
                          setIndex(undefined);
                          setImageLink(null);
                        }}
                      >
                        ×
                      </span>
                    </div>

                    <div className="h-3 ml-3">
                      {/* <input
                        type="file"
                        hidden
                        id="uploadimage49"
                        accept="image/*"
                        className="hidden profile-img-file-input"
                        onChange={(e: any) =>
                          handleAcceptedFiles(e.target.files[0])
                        }
                      /> */}
                      <label
                        onClick={() => {
                          setImageData(undefined);
                          setIndex(undefined);
                          toggleImage();
                        }}
                        // htmlFor="uploadimage49"
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        Change
                      </label>
                    </div>
                  </div>
                ) : (
                  <>
                    {/* <input
                      type="file"
                      hidden
                      id="uploadimage59"
                      accept="image/*"
                      className="hidden profile-img-file-input"
                      onChange={(e: any) =>
                        handleAcceptedFiles(e.target.files[0])
                      }
                    /> */}
                    <label
                      onClick={() => {
                        setImageData(undefined);
                        setIndex(undefined);
                        toggleImage();
                      }}
                      // htmlFor="uploadimage59"
                      className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      {"Add Media"}
                    </label>
                  </>
                )}
              </div>
              <div className="m-4 ml-0 xl:col-span-12">
                {thumbnailUrl?.thumbnail_url ? (
                  <div className="flex items-center">
                    <div className="relative w-40 h-40 ">
                      <img
                        src={getImageUrl(thumbnailUrl?.thumbnail_url)}
                        alt="img"
                        className="w-40 h-40"
                      />

                      <span
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "6px",
                          fontSize: "22px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setImageData(null);
                          setIndex("media");
                          setThumbnailUrl((prev) => ({
                            ...prev,
                            ["thumbnail_url"]: null,
                          }));
                          setThumbnailUrl((prev) => ({
                            ...prev,
                            ["thumbnail_id"]: null,
                          }));
                        }}
                      >
                        ×
                      </span>
                    </div>
                    <div className="h-3 ml-3">
                      <div
                        onClick={() => {
                          setImageData(undefined);
                          toggleImage();
                          setIndex("media");
                        }}
                        // htmlFor="uploadimage49"
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        Change
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      onClick={() => {
                        setImageData(undefined);
                        toggleImage();
                        setIndex("media");
                      }}
                      //htmlFor="uploadimage59"
                      className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      {"Add Thumbnail"}
                    </div>
                  </>
                )}
              </div>
              <div className="xl:col-span-12">
                <CustomDateInput
                  value={formData?.released_at || ""} // Default to empty string if undefined
                  dateOptions={{ dateFormat: "Y-m-d" }}
                  isRequired={true}
                  keyName="released_at"
                  label="Release Date"
                  setDate={(selectedDates) => {
                    if (selectedDates && selectedDates[0]) {
                      setFormData((prev) => ({
                        ...prev,
                        released_at: selectedDates[0].toISOString(),
                      }));
                    }
                  }}
                  isVersioned={!!version?.released_at} // Only true if version.released_at is defined
                  versionedValue={
                    version?.released_at
                      ? moment(new Date(version.released_at)).toISOString()
                      : ""
                  } // Default empty string if not defined
                  placeholder="Select Date"
                  errors={""}
                />
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={() => navigate(PODCAST_LIST_ROUTE)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isLoading}
                  id="addNew"
                  style={{
                    minWidth: "140px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {isLoading ? (
                    <span>
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                      />
                    </span>
                  ) : (
                    "Update podcast"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Update Media"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
      <Drawer
        show={showMeta}
        onHide={toggleMeta}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Edit"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <MetaData
            handleMetaChange={handleMetaChange}
            modelName="podcast"
            metaEdit={metaEdit}
            showError={showError}
            toggleMeta={toggleMeta}
            handleMetaData={handleMetaData}
            loader={loader}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default UpdatePodcast;
